import { FeatureToggleClientService } from 'feature-toggle-client';
const ApplicationInsightsErrorTracking = 'session-expiration-by-inactivity-is-enabled';
export class SessionFeatures {
    static async isSessionExpirationEnabled() {
        return FeatureToggleClientService.getInstance()
            .isFeatureEnabled(ApplicationInsightsErrorTracking, true);
    }
}
